<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row class="mb-3">
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="domain"
              :label="$t('domainName')"
              :rules="[v => !!v || $t('is-required')]"
              outlined
              placeholder="abriron.com"
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="username"
              :label="$t('username')"
              :rules="[v => !!v || $t('is-required')]"
              outlined
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="password"
              :label="$t('password')"
              :rules="[v => !!v || $t('is-required')]"
              outlined
              type="password"
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="rate"
              :label="$t('currencyRate')"
              :rules="[v => !!v || $t('is-required')]"
              outlined
              clearable
              dense
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="registerStatus"
              :label="$t('registerStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="removeStatus"
              :label="$t('removeStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="entrepot"
              :title="$t('entrepotToUse')"
              type="entrepot"
              :outlined="true"
              :value="entrepot"
            />
          </v-col>
          <v-col md="3">
            <v-checkbox
              v-model="portalUpdateStock"
              class="mt-0"
              :label="$t('updateStock')"
              value="yes"
            />
          </v-col>
          <v-col md="3">
            <v-checkbox
              v-model="portalUpdatePrice"
              class="mt-0"
              :label="$t('updatePrice')"
              value="yes"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="px-3"
          >
            <v-btn
              color="green"
              class="mr-0"
              small
              @click="addPaymentMethod"
            >
              {{ $t('addPeymentMethod') }}
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            v-for="(item, index) in paymentItems"
            :key="index"
            class="d-flex pa-0"
          >
            <v-col
              cols="5"
            >
              <autocomplete
                v-model="item.bank"
                :title="$t('bank') + '/' + $t('cash')"
                type="allBankCash"
                :rules="[v => !!v || $t('is-required')]"
                :outlined="true"
                :value="item.bank"
              />
            </v-col>
            <v-col
              cols="6"
            >
              <v-text-field
                v-model="item.value"
                :label="$t('method')"
                :rules="[v => !!v || $t('is-required')]"
                outlined
                clearable
                dense
              />
            </v-col>
            <v-col
              cols="6"
            >
              <v-btn
                x-small
                class="mt-1"
                icon
                @click="remove(index)"
              >
                <v-icon color="pink">
                  mdi-trash-can-outline
                </v-icon>
              </v-btn>
            </v-col>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="$emit('close')"
            >
              {{ $t('cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  // import aicomplete from '../../components/general/AIcomplete/index'
  import autocomplete from '../../components/general/patial/autocomplete'
  import General from '../../../../Mixins/general'
  export default {
    name: 'Customer',
    components: {
      // aicomplete,
      autocomplete,
    },
    mixins: [General],
    data: () => ({
      valid: true,
      updatePrice: null,
      updateStock: null,
      removeStatus: null,
      registerStatus: null,
      portalUpdatePrice: null,
      portalUpdateStock: null,
      entrepot: null,
      entrepotEdit: null,
      username: null,
      paymentItems: [],
      rate: null,
      password: null,
      domain: null,
      type: null,
      render: false,
      isLoading: false,
    }),
    watch: {
    },
    activated () {
      this.show()
    },
    beforeMount () {
      this.statusItems = [
        {
          value: 'not_completed',
          text: this.$t('not_completed'),
        },
        {
          value: 'canceled',
          text: this.$t('canceled'),
        },
        {
          value: 'not_completed',
          text: this.$t('not_completed'),
        },
        {
          value: 'unfulfilled',
          text: this.$t('unfulfilled'),
        },
        {
          value: 'fulfilled',
          text: this.$t('fulfilled'),
        },
      ]
    },
    mounted () {
      this.show()
    },
    methods: {
      addPaymentMethod () {
        this.paymentItems.push({
          bank: null,
          value: null,
        })
      },
      remove (index) {
        this.paymentItems.splice(index, 1)
      },
      create () {
        if (!this.$refs.form.validate()) return false
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'portal', this.$data)
          .then(res => {
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'portal', {
          params: {
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.entrepot = res.entrepot
              app.username = res.portalUsername
              app.password = res.portalPassword
              app.domain = res.portalDomain
              app.portalUpdateStock = res.portalUpdateStock
              app.portalUpdatePrice = res.portalUpdatePrice
              app.registerStatus = res.portalRegisterStatus
              app.removeStatus = res.portalRemoveStatus
              app.paymentItems = res.portalPaymentItems
              app.rate = res.portalCurrencyRate
              app.render = true
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped>
.col{
  height: 55px !important;
}
</style>
